<template>
  <v-dialog v-model="value" persistent max-width="500px"
  transition="dialog-bottom-transition" >
    <v-card class="pa-3 justify-center">
      <v-card-title  color="primary" >
        <v-row>
          <v-col cols="11">
            <span class="titulo">Confirmar registro</span>
            <br>
            <span class="subtitulo no-word-break">Revisa la información antes de enviar</span>
          </v-col>
          <v-col cols="1">
            <v-btn
              icon
              x-small
              @click="onCancelar"
            >
              <v-icon large color="primary">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text :class="`text-medium text-size-1`" style="white-space: pre-line">
        <div class="alertInformativo">
            <v-row>
              <v-col cols="12">
                <v-icon class="titulo mr-2">mdi-clock</v-icon>
                <span class="titulo">Estado del elemento</span>
              </v-col>
              <v-col cols="12">
                <v-chip v-if="oModalDetalleElementos?.idEstadoElemento=='1'" color="primary" label>En vigilancia</v-chip>
                <v-chip v-else-if="oModalDetalleElementos?.idEstadoElemento=='2'" color="success" label>Entregado al propietario</v-chip>
                <v-chip v-else-if="oModalDetalleElementos?.idEstadoElemento=='3'" color="gray" label>En traslado a oficina Av. 68</v-chip>
              </v-col>
              <v-col cols="12">
                <v-icon class="titulo mr-2">mdi-map-marker-outline</v-icon>
                <span class="titulo">Sede</span>
              </v-col>
              <v-col cols="12">
                {{ oModalDetalleElementos?.idsedeMostrar }}
              </v-col>
              <v-col cols="12">
                <v-icon class="titulo mr-2">mdi-file-document</v-icon>
                <span class="titulo">Elemento encontrado</span>
              </v-col>
              <v-col cols="12" v-if="oModalDetalleElementos?.idTipoElementoMostrar">
                <v-chip label outlined class="chip-multiline">
                  {{ oModalDetalleElementos?.idTipoElementoMostrar }}
                </v-chip>
              </v-col>
              <v-col cols="12" v-else-if="oModalDetalleElementos?.idElementoEncontrado">
                <v-chip label outlined  class="chip-multiline">
                  {{ oModalDetalleElementos?.idElementoEncontrado[0]?.elemento }}
                </v-chip>
              </v-col>
              <v-col cols="12" v-else-if="oModalDetalleElementos?.idElementoEncontradoEV68">
                <div v-for="oElementoTemp in oModalDetalleElementos?.idElementoEncontradoEV68" >
                  <v-chip label outlined class="chip-multiline my-2 py-2" v-if="oElementoTemp.idEstado==1">
                    {{ oElementoTemp?.elemento }}
                  </v-chip>
                </div>
              </v-col>

              <!-- Detalle para cuando se encuentra el elemento -->
              <template v-if="oModalDetalleElementos?.idEstadoElemento=='1'">
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-file-document</v-icon>
                  <span class="titulo">Observaciones</span>
                </v-col>
                <v-col cols="12">
                  {{ oModalDetalleElementos?.observacionElemento }}
                </v-col>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-pencil</v-icon>
                  <span class="titulo">Firma de vigilancia</span>
                </v-col>
                <v-col cols="12">
                  <v-row align="center" justify="center" class="firma-item segundoEstilo" no-gutters>
                    <v-col class="pa-0" style="height: 100%;">
                      <div class="d-flex align-center justify-center " style="height: 100%; width: 100%; position: relative;">
                        <img class="segundoEstiloImagen"  :src="oModalDetalleElementos?.firmaRegistra?.TextoRespuesta[0].Base64">
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-image</v-icon>
                  <span class="titulo">Fotos adjuntas ({{ oModalDetalleElementos?.anexosElementos?.TextoRespuesta.length }})</span>
                </v-col>
                <v-col cols="4" v-for="oFoto in oModalDetalleElementos?.anexosElementos?.TextoRespuesta">
                  <img
                    :src="oFoto.Base64"
                    alt="Imagen"
                    style="width: 100%"
                  />
                </v-col>
              </template>

              <!-- Detalle para cuando se entrega al propietario -->
              <template v-else-if="oModalDetalleElementos?.idEstadoElemento=='2'">
                <v-divider></v-divider>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-account</v-icon>
                  <span class="titulo">Datos de quien entrega</span>
                </v-col>
                <v-col cols="12">
                  <span class="titulo2">Nombre completo:</span>
                  <br><br>
                  <span class="black--text">{{ oModalDetalleElementos?.nombreEntregaPropietario }}</span>
                </v-col>
                <v-col cols="12">
                  <span class="titulo2">Cédula:</span>
                  <br><br>
                  <span class="black--text">{{ oModalDetalleElementos?.documentoEntrega }}</span>
                </v-col>
                <v-divider></v-divider>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-account-outline</v-icon>
                  <span class="titulo">Datos de quien recibe</span>
                </v-col>
                <v-col cols="12">
                  <span class="titulo2">Nombre completo:</span>
                  <br><br>
                  <span class="black--text">{{ oModalDetalleElementos?.nombreRecibePropietario }}</span>
                </v-col>
                <v-col cols="12">
                  <span class="titulo2">Cédula:</span>
                  <br><br>
                  <span class="black--text">{{ oModalDetalleElementos?.documentoRecibe }}</span>
                </v-col>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-file-document</v-icon>
                  <span class="titulo">Observaciones</span>
                </v-col>
                <v-col cols="12">
                  {{ oModalDetalleElementos?.observacionEntregarPropietario }}
                </v-col>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-pencil</v-icon>
                  <span class="titulo">Firma de quien entrega</span>
                </v-col>
                <v-col cols="12">
                  <v-row align="center" justify="center" class="firma-item segundoEstilo" no-gutters>
                    <v-col class="pa-0" style="height: 100%;">
                      <div class="d-flex align-center justify-center " style="height: 100%; width: 100%; position: relative;">
                        <img class="segundoEstiloImagen"  :src="oModalDetalleElementos?.firmaEntrega?.TextoRespuesta[0].Base64">
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-pencil</v-icon>
                  <span class="titulo">Firma de quien recibe</span>
                </v-col>
                <v-col cols="12">
                  <v-row align="center" justify="center" class="firma-item segundoEstilo" no-gutters>
                    <v-col class="pa-0" style="height: 100%;">
                      <div class="d-flex align-center justify-center " style="height: 100%; width: 100%; position: relative;">
                        <img class="segundoEstiloImagen"  :src="oModalDetalleElementos?.firmaRecibe?.TextoRespuesta[0].Base64">
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-image</v-icon>
                  <span class="titulo">Fotos adjuntas ({{ oModalDetalleElementos?.anexosEvidenciaPropietario?.TextoRespuesta.length }})</span>
                </v-col>
                <v-col cols="4" v-for="oFoto in oModalDetalleElementos?.anexosEvidenciaPropietario?.TextoRespuesta">
                  <img
                    :src="oFoto.Base64"
                    alt="Imagen"
                    style="width: 100%"
                  />
                </v-col>
              </template>

              <!-- Detalle para cuando se va a transportar para AV68 -->
              <template v-else-if="oModalDetalleElementos?.idEstadoElemento=='3'">
                <v-divider></v-divider>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-account</v-icon>
                  <span class="titulo">Datos de quien entrega</span>
                </v-col>
                <v-col cols="12">
                  <span class="titulo2">Nombre completo:</span>
                  <br><br>
                  <span class="black--text">{{ oModalDetalleElementos?.nombreTraslada }}</span>
                </v-col>
                <v-col cols="12">
                  <span class="titulo2">Cédula:</span>
                  <br><br>
                  <span class="black--text">{{ oModalDetalleElementos?.documentoTraslada }}</span>
                </v-col>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-file-document</v-icon>
                  <span class="titulo">Observaciones</span>
                </v-col>
                <v-col cols="12">
                  {{ oModalDetalleElementos?.observacionEntregarOficina }}
                </v-col>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-pencil</v-icon>
                  <span class="titulo">Firma de quien entrega</span>
                </v-col>
                <v-col cols="12">
                  <v-row align="center" justify="center" class="firma-item segundoEstilo" no-gutters>
                    <v-col class="pa-0" style="height: 100%;">
                      <div class="d-flex align-center justify-center " style="height: 100%; width: 100%; position: relative;">
                        <img class="segundoEstiloImagen"  :src="oModalDetalleElementos?.firmaTraslada?.TextoRespuesta[0].Base64">
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-icon class="titulo mr-2">mdi-image</v-icon>
                  <span class="titulo">Fotos adjuntas ({{ oModalDetalleElementos?.anexosEvidenciaTraslado?.TextoRespuesta.length }})</span>
                </v-col>
                <v-col cols="4" v-for="oFoto in oModalDetalleElementos?.anexosEvidenciaTraslado?.TextoRespuesta">
                  <img
                    :src="oFoto.Base64"
                    alt="Imagen"
                    style="width: 100%"
                  />
                </v-col>
              </template>

              
            </v-row>
          </div>
      </v-card-text>

      <v-col class="align-center text-center" cols="12">
        <v-btn
          class="btn-primary mt-1 margin-auto text-transform-initial"
          color="primary"
          block
          dark
          @click="onAceptar"
          >
          <v-icon color="white" class="mr-2">mdi-check-circle-outline</v-icon> Confirmar y enviar registro
        </v-btn>
      </v-col>
      <!-- <v-col class="align-center text-center" cols="12">
        <v-btn 
          outlined
          class="btn-primary mr-2 text-transform-initial"
          color="primary"
          block
          dark
          @click="onCancelar"
          >
          Volver a editar
        </v-btn>
      </v-col> -->
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name:'DialogEnviarElementosExtraviados',
    props: {
      oModalDetalleElementos: {
          type: Object,
          default: () => {}
      },
      value: {
        type: Boolean,
        default: false
      },
    },
    
    data() {
      return {
        timeoutId: null
      }
    },
    methods: {
      onCancelar(){
        this.$emit('onValidacionModal', false)
      },
      onAceptar(){
        this.$emit('onValidacionModal', true)
      },
    },
    
  }
</script>

<style lang="scss" scoped>
.margin-auto{
  margin: 0 auto;
}
.titulo{
  color: #0056D3;
  font-size: medium;
}
.subtitulo{
  font-size: medium;
}
.alertInformativo{
    margin-top: 14px;
    border-radius: 10px;
    padding: 8px 12px;
    margin-bottom: 8px;
    border: 1.26px solid #1447E6;
    font-family: "Poppins";
}
.segundoEstiloImagen{
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}
.segundoEstilo{
  border: 2px solid #b3cdf2;
  background: white;
  border-radius: 10px;
  height: 100px;
}
.titulo2{
  color:#6A7282
}
.no-word-break {
  word-break: normal;
  overflow-wrap: normal;
  white-space: normal;
}
.chip-multiline {
  white-space: normal !important;
  height: auto !important;
  align-items: flex-start;
}

.chip-multiline .v-chip__content {
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  line-height: 1.4;
}

</style>